<script setup lang="tsx">
import { onBeforeMount, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import http from '@/services/http'
import type { Response, RiskCategory } from '@/models/api-generated'
import { useI18n } from 'vue-i18n'

const model = defineModel<RiskCategory>()
const options = ref<RiskCategory[]>([])
const isLoading = ref(false)

const { t } = useI18n()

onBeforeMount(() => search(''))

async function search(q: string) {
	isLoading.value = true

	const { data } = await http.get<Response<RiskCategory[]>>(`/api/risk/categories?q=${q}`)

	if (data.data) {
		options.value = data.data
	}

	isLoading.value = false
}
</script>

<template>
	<Multiselect
		:multiple="false"
		:show-labels="false"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="name"
		track-by="metaId"
		@search-change="search"
		:placeholder="t('misc.search')"
		:taggable="false"
	>
		<template #option="{ option }">
			<div class="d-flex justify-content-between align-items-center w-100">
				<span>{{ option.name }}</span>
			</div>
		</template>
	</Multiselect>
</template>
